export function useContentMeasurements(container: Ref<ComponentPublicInstance | null>) {
  const contentTop = ref<number>(0)
  const headerHeight = ref<number>(0)
  const contentBottom = ref<number>(0)
  const bannerHeight = ref<number>(0)

  const updateMeasurements = () => {
    if (import.meta.client && container.value?.$el) {
      const rect = container.value.$el.getBoundingClientRect()
      contentTop.value = rect.top || 0
      contentBottom.value = rect.bottom || 0

      const headerEl = document.querySelector('header')
      if (headerEl) {
        const headerRect = headerEl.getBoundingClientRect()
        headerHeight.value = headerRect.height || 0
        bannerHeight.value = headerRect.top || 0
      }
      else {
        bannerHeight.value = 0
      }
    }
  }

  onMounted(() => {
    updateMeasurements()

    if (import.meta.client) {
      // MutationObserver to detect dynamic banner insertion/removal
      const observer = new MutationObserver(updateMeasurements)
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })

      // Also handle window resize, as it might affect offsets
      window.addEventListener('resize', updateMeasurements)

      onUnmounted(() => {
        observer.disconnect()
        window.removeEventListener('resize', updateMeasurements)
      })
    }
  })

  return { contentTop, contentBottom, headerHeight, bannerHeight, updateMeasurements }
}
